import { call, put, takeLatest } from "redux-saga/effects";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import Requester from "common/network/http/Request";
import AuditActions from "reducers/AuditRedux";
import endpoints from "configs/endpoints";
import { userActionTypes } from "action-creators/user";
import { AuditTypes } from "../reducers/AuditRedux";

function* handleRequestAuditData(action) {
  if (!isEmpty(action.data)) {
    try {
      const res = yield call(Requester.get.bind(Requester), endpoints.audit.getUserActivityData, null, null, false, false);

      if (!get(res, "data.error")) {
        yield put(AuditActions.fetchAuditDataSuccess(res));
      } else {
        yield put(AuditActions.fetchAuditDataFailure());
      }
    } catch (err) {
      yield put(AuditActions.fetchAuditDataFailure());
    }
  }
}

export default function* () {
  return [
    yield takeLatest(userActionTypes.ON_LOGIN_SUCCESS, handleRequestAuditData),
    yield takeLatest(AuditTypes.FETCH_AUDIT_DATA, handleRequestAuditData),
  ];
}
